/**
 * PlaceholderScreen (FOUNDATION — v3) — stands in for every vertical-owned
 * screen until its vertical replaces the route entry in src/router.tsx.
 * Renders the screen id + spec pointer so QA screenshots show exactly what is
 * missing. NOT a user surface: verticals must replace every instance before
 * ship. v3: even the scaffolding gets the mascot — no blank panels, ever.
 */
import { Link } from "react-router-dom";
import { Card, Mascot } from "../../design/index.js";

export interface PlaceholderScreenProps {
  /** Human name, e.g. "Deck". */
  title: string;
  /** Screen id(s) in docs/prd/screens.md, e.g. "S-10". */
  screen: string;
  /** Owning vertical per BUILD-PLAN, e.g. "V7 discovery-likes". */
  vertical: string;
}

export function PlaceholderScreen({ title, screen, vertical }: PlaceholderScreenProps) {
  return (
    <div style={{ paddingTop: 48, display: "flex", justifyContent: "center" }}>
      <Card padding="lg" style={{ maxWidth: 420, textAlign: "center" }}>
        <Mascot mood="ko" size={40} />
        <h1 className="h-display" style={{ fontSize: "1.7rem", margin: "10px 0 4px" }}>
          {title}
        </h1>
        <p className="text-dim" style={{ margin: "0 0 6px" }}>
          {screen} — under construction. This route is a foundation placeholder; the{" "}
          <strong>{vertical}</strong> vertical replaces it (see BUILD-PLAN + the pattern in
          src/router.tsx).
        </p>
        <p className="text-faint" style={{ fontSize: "0.85rem" }}>
          Spec: docs/prd/screens.md §{screen}
        </p>
        <Link to="/deck">Back to the deck</Link>
      </Card>
    </div>
  );
}

/** 404 — ©errors.404 with the deck CTA (screens.md global states). */
export function NotFoundScreen() {
  return (
    <div style={{ paddingTop: 64, display: "flex", justifyContent: "center" }}>
      <Card padding="lg" style={{ maxWidth: 420, textAlign: "center" }}>
        <h1 className="h-display" style={{ fontSize: "3rem", margin: 0 }}>
          404
        </h1>
        <Mascot mood="ko" size={36} quip="This page rejected you. Mutual?" />
        <p style={{ marginTop: 10 }}>
          <Link to="/deck">Back to the deck</Link>
        </p>
      </Card>
    </div>
  );
}
